// import something here
import { boot } from 'quasar/wrappers';
import { client } from 'src/client';
import Cookies from 'quasar/src/plugins/Cookies.js';import Notify from 'quasar/src/plugins/Notify.js';;
import { handleUnauthorized } from '@/util/router-helpers';

export default boot(async() => {
   if (process.env.NODE_ENV !== 'production') {
      // Xdebug cookie has wrong domain. Add it as a query param
      client.interceptors.request.use(config => {
         if (Cookies.has('XDEBUG_SESSION')) {
            config.url += `${/\?/.test(config.url) ? '&' : '?'}XDEBUG_SESSION_START=PHPSTORM`;
         }
         // if (Cookies.has('XDEBUG_PROFILE')) {
         //    config.url += `${/\?/.test(config.url) ? '&' : '?'}XDEBUG_PROFILE=PHPSTORM`;
         // }
         return config;
      });
   }
   client.interceptors.response.use(response => response, error => {
      const { response } = error;
      if (!response) {
         return;
      }
      const code = response.status;
      console.log(`Received response code ${code}`);
      switch (code) {
      case 401: // Not logged in
      case 419: // Session expired
         handleUnauthorized();
         break;
      default:
         if (code !== 422) {
            const notification = {
               type: 'negative',
               message: 'Der skete en fejl',
            };
            if (process.env.NODE_ENV !== 'production') {
               if (response.data.exception) {
                  notification.message = response.data.exception;
                  notification.caption = response.data.message;
               } else {
                  notification.message = `${response.status}: ${response.statusText}`;
               }
            }
            Notify.create(notification);
         }
      }
   });
});
